










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import FileExtensionIcons from "./icons/FileExtensionIcons.vue";
import PoliciesIcons from "./icons/PoliciesIcons.vue";
import SourceIcons from "./icons/SourceIcons.vue";
export default Vue.extend({
  components: { SourceIcons, PoliciesIcons, FileExtensionIcons },
});
